/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { faEdit, faSave, faTrashAlt, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useIsPowerShadesAdmin } from '../hooks';
import Button from '../Parts/Button';
import Money from '../Parts/Money';
import TableComponent from './NewItems/TableComponent';
import { useFullHWRItemsByQuoteId } from '../Store/entities/hardwareRequestItems/hooks';
import { useCurrentMultiplier } from '../Store/entities/multipliers/hooks';
import { useAssembliesByQuoteId } from '../Store/entities/assemblies/hooks';
import { useQuoteById } from '../Store/entities/quotes/hooks';

const PartsRow = ({
	deleteItem,
	update,
	isEditable,
	hwItem,
	quoteId,
	forceEditAll,
	massQuantity,
	onDraftChange,
	onEditingChange,
	savingAll,
	resetTrigger,
}) => {
	let { cost = 0.0, msrp = 0.0 } = hwItem;
	const { uom } = hwItem;
	const { part_number, quantity, line_number: lineNumber, description, shipping, is_fascia_combination } = hwItem;
	cost = cost ?? 0.0;
	msrp = msrp ?? 0.0;

	const totalShipping = shipping;

	const isPsAdmin = useIsPowerShadesAdmin();

	const fullParts = useFullHWRItemsByQuoteId(quoteId);
	const fullPart = fullParts.find((p) => p.partNumber === part_number);
	const name = description;

	const currentMultiplier = useCurrentMultiplier(quoteId);

	const multiplier = currentMultiplier.multiplier ?? 1;
 
	const currenctMultiplier = currentMultiplier.currency_multiplier ?? 1;

	const [isEditing, setIsEditing] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const displayMsrp = (msrp * multiplier * currenctMultiplier).toString();
	const [displayQuantity, setDisplayQuantity] = useState(quantity.toString());




	useEffect(() => {
		if (displayQuantity !== quantity.toString()) {
			setDisplayQuantity(quantity.toString());
		}
	}, [isEditing, quantity, resetTrigger]);

	useEffect(() => {
		if (!isEditable || is_fascia_combination) return;
		setIsEditing(!!forceEditAll);
	}, [forceEditAll, isEditable, is_fascia_combination]);

	useEffect(() => {
		if (!isEditable || is_fascia_combination) return;
		if (!isEditing) return;
		if (massQuantity === undefined || massQuantity === null) return;
		if (massQuantity === '') return;
		setDisplayQuantity(massQuantity);
		if (onDraftChange) onDraftChange(lineNumber, massQuantity);
	}, [massQuantity, isEditing]);

	useEffect(() => {
		if (onEditingChange) onEditingChange(lineNumber, isEditing);
	}, [isEditing]);

	const saveHWItem = async () => {
		if (isSaving || savingAll) return;
		setIsSaving(true);
		const convertedAmount = parseFloat(displayMsrp);

		let savingAmount = convertedAmount;

		if (convertedAmount !== displayMsrp * 1) {
			savingAmount = msrp;
		}

		const convertedQuantity = parseFloat(displayQuantity);

		let savingQuantity = convertedQuantity;

		if (convertedQuantity !== displayQuantity * 1) {
			savingQuantity = quantity;
		}

		// Keep the row in edit mode if the save fails so the user can retry.
		try {
			await update(lineNumber, savingQuantity);
			setDisplayQuantity(savingQuantity.toString());
			setIsEditing(false);
		} catch (err) {
			toast.error('Unable to save this hardware item. Please refresh your session and try again.');
		} finally {
			setIsSaving(false);
		}
	};

	const editHwItem = () => {
		if (!isEditable || is_fascia_combination) return;
		setIsEditing(true);
	};

	const deleteHWItem = () => {
		deleteItem(lineNumber);
	};

	const hasChanged = displayQuantity !== quantity.toString();

	const handleReset = () => {
		setDisplayQuantity(quantity.toString());
		if (onDraftChange) onDraftChange(lineNumber, quantity.toString());
	};

	return (
		<tr key={`${lineNumber}`}>
			<td>
				{isEditing ? (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input
							value={displayQuantity}
							className={hasChanged ? 'border-primary' : ""}
							onChange={(e) => {
								setDisplayQuantity(e.target.value);
								if (onDraftChange) onDraftChange(lineNumber, e.target.value);
							}}
							style={{ width: '100%' }}
						/>
						{hasChanged && (
							<FontAwesomeIcon
								icon={faUndo}
								style={{ marginLeft: '5px', cursor: 'pointer', color: '#6c757d' }}
								onClick={handleReset}
								title="Reset to initial value"
							/>
						)}
					</div>
				) : (
					displayQuantity
				)}
			</td>
			<td>{uom}</td>
			<td>{part_number}</td>
			<td>{name }</td>
			
			<td>
				<Money value={displayMsrp} />
			</td>
			{isPsAdmin ? <td>
				<Money value={totalShipping * quantity * currenctMultiplier} />
			</td> : null }
			<td>
				<Money value={quantity * msrp * multiplier * currenctMultiplier} />
			</td>
			{(isEditable && !is_fascia_combination) ? (
				<td>
					<span className="local-bootstrap">
						<Row className="g-0">
							<Col>
								<Button
									onClick={deleteHWItem}
									fullWidth
									color="light"
									size="sm"
									disabled={isSaving || savingAll}
								>
									<FontAwesomeIcon icon={faTrashAlt} />
								</Button>
							</Col>
						</Row>
					</span>
				</td>
			) : (
				isEditable
					? <td title='This part is a fascia combination. Please edit in the combine fascia screen.' >
						<FaInfoCircle />
					</td>
					: null
			)}
		</tr>
	);
};

const PartsTable = ({ isEditable, hwRequestItems, deleteItem, update, quoteType, quoteId }) => {
	const globalParts = useFullHWRItemsByQuoteId(quoteId);

	const isPsAdmin = useIsPowerShadesAdmin();

	const currentMultiplier = useCurrentMultiplier(quoteId);

	const [editAll, setEditAll] = useState(false);
	const [massQuantity, setMassQuantity] = useState('');
	const [savingAll, setSavingAll] = useState(false);
	const [drafts, setDrafts] = useState({});
	const [editingRows, setEditingRows] = useState({});
	const [resetTrigger, setResetTrigger] = useState(0);
	const [saveAllError, setSaveAllError] = useState('');

	const assemblies = useAssembliesByQuoteId(quoteId);
	const quote = useQuoteById(quoteId);


	const onDraftChange = (lineNumber, val) => {
		setDrafts((prev) => ({ ...prev, [lineNumber]: val }));
	};

	const onEditingChange = (lineNumber, isRowEditing) => {
		setEditingRows((prev) => ({ ...prev, [lineNumber]: !!isRowEditing }));
	};

	const originalQuantities = useMemo(() => {
		const map = {};
		(hwRequestItems || []).forEach((h) => {
			map[h.line_number] = h.quantity;
		});
		return map;
	}, [hwRequestItems]);

	const hasPendingChanges = useMemo(() => Object.keys(drafts).some((line) => {
		const originalVal = originalQuantities[line];
		if (originalVal === undefined) return false;
		const draftVal = drafts[line];
		return draftVal !== undefined && draftVal !== originalVal.toString();
	}), [drafts, originalQuantities]);

	const prevPending = useRef(hasPendingChanges);
	const [overrideColor, setOverrideColor] = useState(null);

	useEffect(() => {
		if (hasPendingChanges && !prevPending.current) {
			let count = 0;
			const interval = setInterval(() => {
				setOverrideColor((prev) => (prev === 'green' ? 'light' : 'green'));
				count += 1;
				if (count >= 6) {
					clearInterval(interval);
					setOverrideColor(null);
				}
			}, 250);
			return () => clearInterval(interval);
		}
		if (!hasPendingChanges) {
			setOverrideColor(null);
		}
		prevPending.current = hasPendingChanges;
		return undefined;
	}, [hasPendingChanges]);

	const hasAnyRowEditing = useMemo(
		() => Object.values(editingRows).some(Boolean),
		[editingRows]
	);

	const handleSaveAll = async () => {
		if (savingAll) return;
		setSavingAll(true);
		setSaveAllError('');
		const failedLines = [];
		try {
			const linesToSave = Object.keys(editingRows)
				.filter((k) => editingRows[k])
				.map((k) => parseInt(k, 10));

			const hasMass = massQuantity !== '' && !Number.isNaN(parseFloat(massQuantity));

			await linesToSave.reduce((promise, line) => promise.then(async () => {
				const qtyStr = drafts[line];
				let qty = qtyStr !== undefined ? parseFloat(qtyStr) : undefined;
				if (qty === undefined || Number.isNaN(qty)) {
					qty = originalQuantities[line] ?? 0;
				}

				if (!hasMass) {
					const original = originalQuantities[line];
					if (original === undefined || original === qty) {
						return;
					}
				}

				try {
					await update(line, qty);
				} catch (err) {
					failedLines.push(line);
				}
			}), Promise.resolve());
		} finally {
			setSavingAll(false);
			if (failedLines.length > 0) {
				setEditAll(true);
				const message = failedLines.length === 1
					? `Failed to save line ${failedLines[0]}.`
					: `Failed to save ${failedLines.length} hardware lines.`;
				setSaveAllError(`${message} Your session may have expired.`);
				toast.error(`${message} Please refresh your session and try again.`);
				return;
			}

			setDrafts({});
			setEditingRows({});
			setMassQuantity('');
			setEditAll(false);
		}
	};

	const rows = hwRequestItems.map((hw) => {
		const hwItemToUse = { ...hw };
		if (globalParts) {
			const hwPart = globalParts.find((p) => p.partNumber === hwItemToUse.part_number);

			const uom = hwPart ? hwPart.uom : '';
			const description = hwPart ? hwPart.name : '';
			hwItemToUse.uom = uom;
			hwItemToUse.description = description;
		}
		
		return (
			<PartsRow
				quoteId={quoteId}
				quoteType={quoteType.toLowerCase()}
				update={update}
				deleteItem={deleteItem}
				key={hwItemToUse.line_number}
				hwItem={hwItemToUse}
				isEditable={isEditable}
				forceEditAll={editAll}
				massQuantity={massQuantity}
				onDraftChange={onDraftChange}
				onEditingChange={onEditingChange}
				savingAll={savingAll}
				resetTrigger={resetTrigger}
			/>
		);
	});

	const handleMassReset = () => {
		setMassQuantity('');
		setDrafts({});
		setResetTrigger((prev) => prev + 1);
	};

	const controlRow = (
		<tr key="controls-row">
			<td>
				{isEditable && hasAnyRowEditing ? (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input
							placeholder="Mass Qty Edit"
							value={massQuantity}
							onChange={(e) => setMassQuantity(e.target.value)}
							disabled={savingAll}
							style={{ width: '100%' }}
						/>
						{massQuantity !== '' && (
							<FontAwesomeIcon
								icon={faUndo}
								style={{ marginLeft: '5px', cursor: 'pointer', color: '#6c757d' }}
								onClick={handleMassReset}
								title="Reset all fields"
							/>
						)}
					</div>
				) : null}
			</td>
			<td />
			<td />
			<td />
			<td />
			{isPsAdmin ? <td /> : null}
			<td />
			{isEditable ? (
				<td>
					<span className="local-bootstrap">
						<Row className="g-0">
							{editAll ? (
								<Col>
									<Button
										fullWidth
										color={overrideColor || (hasPendingChanges ? 'green' : 'light')}
										size="sm"
										onClick={handleSaveAll}
										disabled={!isEditable || savingAll}
										title="Save All"
									>
										<FontAwesomeIcon icon={faSave} />
									</Button>
								</Col>
							) : (
								<Col>
									<Button
										fullWidth
										color="light"
										size="sm"
										onClick={() => setEditAll(true)}
										disabled={savingAll}
										title="Edit All"
									>
										<FontAwesomeIcon icon={faEdit} />
									</Button>
								</Col>
							)}
						</Row>
					</span>
				</td>
			) : null}
		</tr>
	);

	const errorRow = saveAllError ? (
		<tr key="save-all-error-row">
			<td colSpan={isPsAdmin ? 8 : 7} style={{ color: '#a40000', fontWeight: 600 }}>
				{saveAllError}
			</td>
		</tr>
	) : null;

	const rowsWithControl = (isEditable && hwRequestItems.length > 0)
		? [controlRow, ...(errorRow ? [errorRow] : []), ...rows]
		: rows;

	const columns = [
		{
			display: 'Quantity',
		},
		{
			display: 'Unit of Measurement',
		},
		{
			display: 'SKU',
		},

		{
			display: 'Description'
		},

	];

	columns.push({
		display: `${currentMultiplier.label} (${currentMultiplier.currency})`,
	});
	
	if (isPsAdmin) {
		const shippingTitle = assemblies?.length > 0
			? "Shipping" : ((quote.ship_order ?? true)
				? "Shipping and Processing" : "Processing");
		columns.push({
			display: shippingTitle
		});
	}

	columns.push({
		display: 'Total',
	});

	if (isEditable) {
		columns.push({
			display: 'Actions',
		});
	}

	return (
		<TableComponent
			quoteType={quoteType}
			rows={rowsWithControl}
			columns={columns}
			key="ItemsParts"
			ISO={{
				idk: 0,
			}}
			title="Hardware Requests"
		/>
	);
};

export default PartsTable;
